export default function () {
    return {
        treeTypeList: [],
        trees: [],
        treeStatus: [],
    }
}